// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { controlsContainerStyles } from "@sc/Overrides/Widgets/ProductList/ProductListControlsContainer";
import Filter from "@sc/XDL/Icons/Filter";
import { fontConfig } from "@sc/XDL/PreStyle/typography";
import { createLinkIconStyles, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

const sharedColumnStyles = css`
    display: flex;
    align-items: center;
`;

controlsContainerStyles.container = {
    css: css`
        width: 100%;
        margin-bottom: 4px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        row-gap: 8px;
        ${xScreen("lte", "md")} {
            flex-wrap: nowrap;
            & .hide-on-tablet {
                display: none;
            }
        }
    `,
};

controlsContainerStyles.leftColumn = {
    css: css`
        ${sharedColumnStyles}
        gap: 20px;
        & div[data-test-selector="productList_pagination"] {
            margin: 0 !important;
        }
        ${xScreen("lte", "md")} {
            max-width: unset;
            width: auto;
        }
    `,
};

controlsContainerStyles.rightColumn = {
    css: css`
        ${sharedColumnStyles}
        max-width: 317px;
        & div[data-test-selector="productList_pagination"] {
            margin: 0 !important;
        }
        ${xScreen("lte", "md")} {
            max-width: unset;
            width: auto;
            justify-content: flex-end;
        }
    `,
};

controlsContainerStyles.filterBtn = {
    ...createLinkIconStyles(Filter, {
        typographyProps: { size: 16, lineHeight: "19px" },
        icon: {
            iconProps: {
                size: 16,
            },
        },
        css: css`
            display: none;
            ${xScreen("lte", "md")} {
                display: inline-flex;
            }
        `,
    }),
};
